import React, { Component } from "react";
import { connect } from "react-redux";
import { SET_VALID } from "../constants";
import { currentLocale } from "../locale";
import { contains, and, toLower } from "ramda";
import IframeComponent from "../components/iframe";
import moment from "moment";
import { head, isEmpty, not } from "ramda";
import { converter } from "../lib/converter";
import '../style/sign.scss'


export const Pdf = ({ pdf, waiver, userAgent }) => {
  let type;
  if (contains("html", waiver.participantPdf)) {
    type = "text/html";
  } else {
    type = "application/pdf";
  }
  return (
    <React.Fragment>
          {and(
              contains("html", waiver.participantPdf),
              contains("mac os", toLower(userAgent))
          ) ? (
        <IframeComponent src={pdf} height="100%" width="100%" /> 
      ) : (
        <object
          data={pdf}
          type={type}
          style={{ width: "100%", height: "900px" }}
          className="columns"
        >
          <a
            className="column is-half is-offset-one-quarter button is-large is-text"
            href={pdf}
            target="_blank"
            rel="noopener noreferrer"
          >
            {converter.convert(`${currentLocale.download}`)}
          </a>
        </object>
      )}
    </React.Fragment>
  );
};

class Step5 extends Component {
  state = { userAgent: "" };
  componentWillMount() {
    //checking to see if this is first time through (or if they're going back to edit)
    if (
      not(isEmpty(head(this.props.signingInfo.participants).participantName))
    ) {
      this.props.skippedBackwards();
    }

    //checking to see if pdfs are expired and if so it re gets
    if (moment().isAfter(`${this.props.waiver.pdfExpires}`)) {
      this.props.getCurrentWaiver();
    }
    this.props.dispatch({ type: SET_VALID, payload: true });
    this.setState({ userAgent: window.navigator.userAgent });
  }

  render() {
    const { waiver, minorPage, signingInfo } = this.props;
    const { userAgent } = this.state;
    return (
      <div>
        {minorPage === true &&
        signingInfo.role === 3 &&
        (waiver.participantPdf && waiver.guardianPdf) ? (
          <Pdf pdf={waiver.guardianPdf} waiver={waiver} userAgent={userAgent} />
        ) : signingInfo.role === 2 &&
          (waiver.participantPdf && waiver.guardianPdf) ? (
          <Pdf pdf={waiver.guardianPdf} waiver={waiver} userAgent={userAgent} />
        ) : (
          <Pdf
            pdf={waiver.participantPdf}
            waiver={waiver}
            userAgent={userAgent}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = state => ({});
const mapActionToProps = dispatch => ({
  dispatch
});

export default connect(
  mapStateToProps,
  mapActionToProps
)(Step5);
